<template>
  <div class="card">
    <div class="card-header" data-background-color="magenta-dark">
        <h4>Ultima posición reportada al momento de la búsqueda</h4>
        <div class="actions-container">
          <button @click="refresh" class="btn-link">Refrescar</button>
          <slot></slot>
        </div>
    </div>

    <div class="card-content">
      <table>
        <tbody>
          <tr>
            <td class="title">Tiempo</td>
            <td>{{ `Hace ${timeDifference}` }}</td>
          </tr>
          <tr>
            <td class="title">Dirección</td>
            <td>{{ address }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Utils from "src/utils";

export default {
  props: {
    timestamp: Number,
    address: String,
    refresh: Function
  },

  computed: {
    timeDifference() {
      return Utils.getTimeDifference(this.timestamp);
    }
  }
};
</script>
<style lang="scss" scoped>
.card-header {
  display: flex;

  .btn-link {
    color: white;
    text-decoration: none;
    padding-right: 30px;
    padding-left: 30px;
  }

  h4 {
    margin-right: auto;
    font-weight: bold;
    margin: 0;
  }
}

.actions-container {
  margin-left: auto;
  display: inline-flex;
}


table {
  margin: 10px auto;

  & tr {
    padding: 5px;
  }

  & td {
    padding: 5px 10px;
    text-align: left;

    &.title {
      font-weight: bolder;
    }
  }
}
</style>




// WEBPACK FOOTER //
// LastPositionTable.vue?b4686ea4